import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-withdrawn-success-pop-up',
  templateUrl: './withdrawn-success-pop-up.component.html',
  styleUrls: ['./withdrawn-success-pop-up.component.css']
})
export class WithdrawnSuccessPopUpComponent implements OnInit {

  private readonly dialogRef: MatDialogRef<WithdrawnSuccessPopUpComponent>;

  constructor(
    dialogRef: MatDialogRef<WithdrawnSuccessPopUpComponent>) {
    this.dialogRef = dialogRef;
  }

  ngOnInit(): void {
  }

  decline(): void {
    this.dialogRef.close();
  }
}
